export const getOffset = (element: HTMLElement) => {
  let offsetTop = 0;
  let offsetLeft = 0;
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
    if (!isNaN(element.offsetLeft)) {
      offsetLeft += element.offsetLeft;
    }
  } while ((element = element.offsetParent as HTMLElement));
  return { offsetTop, offsetLeft };
};
